/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * User-selectable caption sizes as multipliers of the base caption size
 * ({CC_BASE_FONT_SIZE_VW_TV} on TV, {CC_BASE_FONT_SIZE_VW_BROWSER} on
 * browser).
 */
export enum ClosedCaptionFontSize {
  Small = 1,
  Medium = 1.5,
  Large = 2,
  ExtraLarge = 2.5
}
